import { utils as gleamerUtils } from '@gleamer/ui';
import { CommandsManager } from '@ohif/core';
import { ToolButton } from '@ohif/ui-next';
import { useAtomValue } from 'jotai';
import React from 'react';
import { useDisplayPredictions } from '../contexts/predictions.hooks';
import { preAnnotationsReadAtom } from '../preAnnotations/droppedPreAnnotations';
import { shouldShowPreAnnotations } from '../preAnnotations/shouldShowPreAnnotations';

type PreAnnotationsToggleButtonProps = {
  id: string;
  commandsManager: CommandsManager;
};

/**
 * Hides or shows every Pre-annotation, like the `a` hotkey. Shown with the
 * Predictions panel only (the bac mode, once a JSON was read), so every mode
 * can carry it.
 */
export function PreAnnotationsToggleButton({
  id,
  commandsManager,
}: PreAnnotationsToggleButtonProps) {
  const preAnnotationsRead = useAtomValue(preAnnotationsReadAtom);
  const [displayPredictions] = useDisplayPredictions();

  if (
    !shouldShowPreAnnotations({
      modeName: gleamerUtils.getMode(),
      preAnnotationsRead,
    })
  ) {
    return null;
  }

  return (
    <ToolButton
      id={id}
      icon="gleamer-predictions"
      label="Pre-annotations"
      tooltip={`${displayPredictions ? 'Hide' : 'Show'} Pre-annotations (A)`}
      isActive={displayPredictions}
      onInteraction={() =>
        commandsManager.runCommand('togglePredictionsDisplay')
      }
    />
  );
}
